import React, { PropTypes, Component } from "react";
import { NitroText, NitroButton, NitroHeading } from "nitro-components";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import styled from "styled-components";

import { media } from "style-utils";

const RadioButtonContainer = styled.div`
	 display: flex;
	 flex-wrap: wrap;

	 input[type="radio"] {
    	display:none;
    	opacity: 0;
	}

	  ${media.mobile`
      		 justify-content: center;
    	`}


	>section {
		margin: 5px;

		${media.mobile`
      		 margin: 8px;
    	`}
	}

	label {
	    display:inline-block;
	    background-color: ${props => props.theme.color.white};
	    padding: 10px 0px;
	    border: 1px solid ${props => props.theme.color.border};
	    border-radius: 60px; 
	    height: 40px;
	    min-width: 124px;
	    text-align: center;
	    color: ${props => props.theme.color.base2};

	}

	label:hover {
  		background-color: ${props => props.theme.color.primary};
  		color: ${props => props.theme.color.white};
  		cursor: pointer;
	}

	input[type="radio"]:checked + label { 
	    background-color:${props => props.theme.color.primary};
	    border-color: ${props => props.theme.color.primary};
	    color: ${props => props.theme.color.white};
	}

	
	input[type="radio"]:disabled + label { 
	   background-color: ${props => props.theme.color.white};
	    border: 1px solid ${props => props.theme.color.border};
		color: ${props => props.theme.color.base2};
	    opacity: 0.5;

	    &:hover {

	    	cursor: default;
	    }
	}
`;

class CustomRButtons extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.onChange = this.onChange.bind(this);
	}

	onChange = (key, id) => {
		this.props.action(key, id);
	};

	render() {
		const { data, id, selectedValue } = this.props;
		return (
			<section>
				<RadioButtonContainer>
					{data.map((item, index) => {
						const key = `${id}_${index}`;
						const inputAttrs = {
							type: "radio",
							id: key,
							name: id,
							value: item.Value,
							disabled: !item.Enabled,
							onClick: () => {
								this.onChange(id, item.Key);
							},
							onChange: () => {}
						};

						if (typeof selectedValue !== "undefined") {
							inputAttrs.checked = item.Key === selectedValue;
						}

						return (
							<section key={key}>
								<input {...inputAttrs} />
								<label htmlFor={key}>{item.Value}</label>
							</section>
						);
					})}
				</RadioButtonContainer>
			</section>
		);
	}
}

CustomRButtons.propTypes = {
	id: PropTypes.string,
	action: PropTypes.func,
	data: PropTypes.array,
	selectedValue: PropTypes.number
};

export default CustomRButtons;



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/components/CustomRButtons.js